<template>
	<BaseCard :alt="alt" v-hover="{ active: 'scale-95', impact: 'soft' }">
		<ItemInner
			class="relative px-3 py-4"
			:price="price"
			:src="src"
			:collection="collection"
			:name="name"
			:color="color"
			:preloader="preloader"
		>
			<div
				class="text-label-secondary absolute top-3 right-3 text-right text-xs font-medium"
			>
				{{ chance }}%
			</div>
		</ItemInner>
	</BaseCard>
</template>
<script setup lang="ts">
import BaseCard from './BaseCard.vue'
import ItemInner from './ItemInner.vue'

defineProps<{
	alt?: boolean
	preloader?: string
	collection: string
	name: string
	src: string
	price: number
	chance: number
	color: 'red' | 'orange' | 'blue' | 'pink'
}>()
</script>
